import React, { useState, useEffect } from 'react';
import {useHistory} from 'react-router-dom';
import {
  Drawer, List, ListItem, ListItemIcon, ListItemText, Button, Typography, CircularProgress, Box, Divider,
  } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {USER_ICON, ADMIN_USER_ICON, ChallanIcon, UserIcon, LogoutIcon, DeleteUserIcon, LanguageIcon, AboutIcon, TermsIcon, SupportIcon } from "../assets/constants/Icons";
import { BUTTON_PRIMARY, BUTTON_WARNING, SUCCESS, TOAST_SUCCESS, HIVEBOARD, DRAWER_MENU_LIST, DEFAULT_DRAWER_MENU_LIST } from "../assets/constants/Constants";
import { MENU_DRAWER, LOGOUT} from '../assets/constants/PageList';
import ShowToast from "./ToastComponent";
import { useTranslation } from 'react-i18next';
import { APP_YELLOW_GREEN_COLOR, APP_LAVENDAR_GREY_COLOR, APP_DARK_PURPLE_COLOR, APP_WHITE_COLOR, APP_ENGLISH_VIOLET_COLOR } from '../assets/constants/Colors';
import CustomDialog from './CustomDialog';
import { getSecureItemFromSpecificStorage } from '../lib/BrowserStorageAccessMiddleware';
import { LOCAL_STORAGE, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS, LS_CUSTOMER, USER_INFO, PERMISSIONS_LIST } from '../assets/constants/BrowserStorageKeys';
import { deleteUserAccount } from '../api/api';
import { getPathForNextPage, clearLocalStorageForUser, LanguageSelector } from '../lib/Utils';
import MainHeader from './MainHeader';

const CustomDrawer = (props) => {
  const history = useHistory();
  const { t } = useTranslation();
  const theme = useTheme();
  const colorScheme = theme.palette.mode;
  const tenantAndAssignmentSettings = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS);
  const [modalVisible, setModalVisible] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [loaderdisabled, setLoaderDisabled] = useState(false);
  const [info, setInfo] = useState({});
  const {isDrawerOpened} = props.location.state || false;
  const sideDrawerOptions = t('sideDrawer') !== 'sideDrawer' ? t('sideDrawer') : null;
  // const customer = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_CUSTOMER);
  // const sideDrawerOptions = customer === HIVEBOARD ? { drawerMenuList: DRAWER_MENU_LIST } : null;
  const[isUserLogin, setIsUserLogin] = useState(false);
  const isAdminMenuEnabled = tenantAndAssignmentSettings?.usecase_settings?.admin_menu_enable?.value;

  const permissionsList = getSecureItemFromSpecificStorage(LOCAL_STORAGE, PERMISSIONS_LIST);
  useEffect (() => {
    getUserInfo();

  },[])

  const isDark = colorScheme === 'dark';

const getUserInfo = async () => {
  const anonymousUser = {
        username: "Guest User",
        email: "NA",
        mobile_number: "",
      };

  try {
    const userData = await getSecureItemFromSpecificStorage(
      LOCAL_STORAGE,
      USER_INFO
    );

    if (userData) {
      setIsUserLogin(true);
      setInfo(userData);
    } else {
      setInfo(anonymousUser);
    }
  } catch (e) {
    console.error("getUserInfo error:", e);
    // Optional fallback even on error
    setInfo(anonymousUser);
  }
};


  /**
   * Handles the logout functionality.
   * Clears user information and tokens from local storage.
   * Redirects the user to the login page.
   * @returns {null} Returns null if any required data is missing.
   * @throws {Error} Throws an error if there is an issue clearing app data.
   */
  const handleLogout = async () => {
    try {
      clearLocalStorageForUser(getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_CUSTOMER))
      ShowToast(t('success_msg_successfully_logged_out'), TOAST_SUCCESS);
      props.history.replace( getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_CUSTOMER) === HIVEBOARD ? '/login-page' : '/');//getPathForNextPage(MENU_DRAWER, LOGOUT));
    } catch (error) {
      setLoaderDisabled(false);
      console.error('Error clearing app data.', error);
    }
  };



  const cancelLogout = () => {
    setModalVisible(false);
  };

  const openDeleteAccountModal = async () => {
      try {
        setDeleteModalVisible(true);
      } catch (error) {
        console.error('Error clearing app data.', error);
      }
  };

  const closeDeleteModal = () => {
    setDeleteModalVisible(false);
  }

  const handleDeleteAccount = async () => {
    try {
      setDeleteModalVisible(false);
      const response = await deleteUserAccount();
      if(response.status === SUCCESS){
        ShowToast(t('successAccountDeleted'),TOAST_SUCCESS)
        clearLocalStorageForUser()
        props.history.replace(getPathForNextPage(MENU_DRAWER, LOGOUT));
      }
    } catch (error) {
      console.error("CustomDrawer.js - handleDeleteAccount", error);
    }
  }



  const handleCloseDrawer = () => {
    window.history.back();
  };

  const navigateToProfileUpdate = () => {
    // props.history.push('/profile-update') // Currently commented for blue dart use case
  }



  const MenuList = ({ menuItem, className = '' }) => {
    if (menuItem?.isVersion) {
      return (
        <>
       <Divider className="divider" />
        <ListItem key={menuItem.id}>
          <Typography variant="body1" className="versionName">
            {t(menuItem.label)} {menuItem.value}
          </Typography>
        </ListItem>
         </>
        
      )
    }
    if (menuItem?.isLanguageSelector) {
      return (
        <ListItem key={menuItem.id}>
          <ListItemIcon>{drawerIconMap[menuItem.icon]}</ListItemIcon>
          <LanguageSelector width={200} placement="top" />
          
        </ListItem>
      )
    }
    const icon = drawerIconMap[menuItem?.icon] || menuItem?.icon || null;
    if (className === 'redio') {
      return (
        <>
          <ListItem className='redio' component={Button} onClick={() => navigateToDrawerMenu(menuItem)}>
            {menuItem?.icon ? <ListItemIcon> {icon} </ListItemIcon> : ""}
            <span style={{textTransform: 'none', color: "#222222", fontFamily: 'Poppins-Medium', fontSize: '16px', fontWeight: '500'}}>{t(menuItem?.label)}</span>
          </ListItem>
          <Divider className="divider" />
        </>
      )
    }
    return (
      <>
        <ListItem className={className} component={Button} sx={{ backgroundColor: colorScheme == 'dark' ? APP_ENGLISH_VIOLET_COLOR : APP_WHITE_COLOR }} onClick={() => navigateToDrawerMenu(menuItem)}>
          {icon ? <ListItemIcon>{icon}</ListItemIcon> : ""}
          <ListItemText primary={t(menuItem?.label)} sx={menuItemTextStyle} />
        </ListItem>
        <Divider className="divider" />
      </>
    )
  }

  const navigateToDrawerMenu = (menuItem) => {
    if (menuItem?.isLogout) return setModalVisible(true);
    if (menuItem?.isDeleteAccount) return openDeleteAccountModal();
    if (menuItem?.target) return history.push({ pathname: getPathForNextPage(MENU_DRAWER, menuItem.target), state: menuItem.state });
    if (menuItem?.route) return history.push(menuItem.route);
    if (menuItem?.value) return history.push({ pathname: '/drawer-menu-content', state: { content: menuItem.value, title: menuItem.label } });
    setModalVisible(true);
  }

  const menuItemTextStyle = { textTransform: 'none', color: colorScheme == 'dark' ? APP_WHITE_COLOR : APP_DARK_PURPLE_COLOR };

  const drawerIconMap = {
    admin: <ADMIN_USER_ICON isDark={isDark} />,
    userAccount: <UserIcon isDark={isDark} />,
    invoice: <ChallanIcon isDark={isDark} />,
    support: <SupportIcon isDark={isDark} />,
    terms: <TermsIcon isDark={isDark} />,
    about: <AboutIcon isDark={isDark} />,
    language: <LanguageIcon isDark={isDark} />,
    deleteAccount: <DeleteUserIcon isDark={isDark} />,
    logout: <LogoutIcon isDark={isDark} />,
  };

  const shouldShowDrawerMenuItem = (item) => {
    if (item.requiresLogin && !isUserLogin) return false;
    if (item.permission && !permissionsList?.includes(item.permission)) return false;
    if (item.adminOnly && !isAdminMenuEnabled) return false;
    if (item.pricingOnly && !tenantAndAssignmentSettings?.is_pricing) return false;
    return true;
  };

  return (
    <Box className='sidebar-container'>
    <Box className='main-container'>
      <Box className='main'>
        <Drawer
          anchor="left"
          open={true}
          onClose={handleCloseDrawer}
          className='MuiDrawer-paper'
          >
          <MainHeader isDrawerOpened={isDrawerOpened}/>
          <Box className="profileContent">
            {!sideDrawerOptions ?
            <>
            <Box className="profileInfo" sx={{display:'flex', flexDirection:'row',alignItems:'center', backgroundColor:APP_DARK_PURPLE_COLOR}}>
              <Box className="profileImage" sx={{paddingLeft:2}} onClick= {navigateToProfileUpdate}> <USER_ICON /></Box> 
              <Box className="profileInfoView" sx={{padding:3, maxWidth: 300}}>
                <Typography className="profileName" variant="body1" sx ={{color: APP_YELLOW_GREEN_COLOR, fontFamily:'SFProDisplay-Bold'}}>{info?.username}</Typography>
                <Typography className="profileEmail" variant="body2" color="textSecondary" sx={{color: APP_LAVENDAR_GREY_COLOR, fontFamily:'SFProText-Regular', wordWrap: 'break-word'}}>{info?.email}</Typography>
                <Typography className="contact" variant="body2" color="textSecondary" sx={{color: APP_LAVENDAR_GREY_COLOR, fontFamily:'SFProText-Regular'}}>{info?.mobile_number}</Typography>
                <Typography className="contact" variant="body2" color="textSecondary" sx={{color: APP_LAVENDAR_GREY_COLOR, fontFamily:'SFProText-Regular'}}>{info?.user_company}</Typography>
              </Box>
            </Box>
            <Divider className="divider" />
            </>
            : ""}
             {sideDrawerOptions?.drawerMenuList?.length > 0 ?
              <List sx={{ backgroundColor: colorScheme == 'dark' ? APP_ENGLISH_VIOLET_COLOR : APP_WHITE_COLOR }}>
                {sideDrawerOptions?.drawerMenuList?.map(item => (
                 <MenuList menuItem={item} key={item?.id} className="redio" />
              ))}
              </List> :
            <>
            <List>
              {DEFAULT_DRAWER_MENU_LIST.filter(shouldShowDrawerMenuItem).map(item => (
                <MenuList menuItem={item} key={item.id} />
              ))}
          </List>
            </>}
          </Box>
        </Drawer>
        <CustomDialog
          dialogVisible={modalVisible}
          onClose={cancelLogout}
          handleCancel={cancelLogout}
          handleAccept={handleLogout}
          dialogTitle={t('button_logout')}
          dialogContentText={t('are_you_sure_to_logout')}
          buttonOneTitle={t('button_cancel')}
          buttonTwoTitle={t('yesBtnText')}
          buttonProps={{buttonOne : {variant : "outlined",customClass : "cancel-button", type : BUTTON_WARNING} ,buttonTwo : {type :BUTTON_PRIMARY }}}
        />
         <CustomDialog
          dialogVisible={deleteModalVisible}
          onClose={() => this.setState({showBookingConfirmationModal: false})}
          handleCancel={closeDeleteModal}
          handleAccept={handleDeleteAccount}
          dialogTitle={t('confirmText')}
          dialogContentText={t('alert_delete_account_msg')}
          buttonOneTitle={t('button_cancel')}
          buttonTwoTitle={t('yesBtnText')}
          buttonProps={{buttonOne : {type : BUTTON_WARNING },buttonTwo : {type : BUTTON_PRIMARY}}}
        />
        {loaderdisabled && (
          <Box className="loaderOuterView">
            <CircularProgress />
          </Box>
        )}
      </Box>
    </Box>
  </Box>
  );
};

export default CustomDrawer;